/* eslint-disable react/no-array-index-key */
// Items are static and are never reordered or filtered. Unique commentaryId can be used as key when available.

import React from 'react';
import { useIntl } from 'react-intl';
import { Commentary, CommentaryTypeLabel } from '../commentary.types';
import { CommentaryListOpenCommentary } from '../list/CommentaryListOpenCommentary';
import { CommentaryListPaperCommentary } from '../list/CommentaryListPaperCommentary';
import { CommentaryListHybridCommentary } from '../list/CommentaryListHybridCommentary';
import {
  ModalScrollableContainer,
  ModalScrollableContent,
  ModalScrollableHeader,
} from '../../components/modal';
import styles from './commentary_modal_content.module.scss';

type Props = {
  commentaries: Array<Commentary>;
  closeModal: () => void;
  commentaryClicked: Function;
  source: string;
  isOpen: boolean;
};

export const CommentaryModalContent = ({
  commentaries,
  closeModal,
  commentaryClicked,
  source,
  isOpen,
}: Props) => {
  const intl = useIntl();
  const headerWording = intl.formatMessage(
    { id: 'commentary/modal/CommentaryModalContent.tsx/commentary/1' },
    { count: commentaries.length },
  );

  return (
    <ModalScrollableContainer isOpen={isOpen} onRequestClose={closeModal}>
      <ModalScrollableHeader title={headerWording} onClose={closeModal} />
      <ModalScrollableContent>
        <div className={styles.content}>
          {commentaries.map((commentary: Commentary, index: number) => {
            if (commentary.typeLabel === CommentaryTypeLabel.HYBRID) {
              return (
                <CommentaryListHybridCommentary
                  commentary={commentary}
                  key={index}
                  source={source}
                  onCommentaryClicked={commentaryClicked}
                />
              );
            }
            if (commentary.typeLabel === CommentaryTypeLabel.PAPER) {
              return (
                <CommentaryListPaperCommentary
                  key={index}
                  commentary={commentary}
                />
              );
            }
            return (
              <CommentaryListOpenCommentary
                key={index}
                commentary={commentary}
                source={source}
                onCommentaryClicked={commentaryClicked}
              />
            );
          })}
        </div>
      </ModalScrollableContent>
    </ModalScrollableContainer>
  );
};
